import { APIErrorResponse, ClientStandardTime } from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'

export type UseClientStandardTimesProps = {
  clientId?: number | null
}

export const useClientStandardTimes = ({
  clientId,
}: UseClientStandardTimesProps): UseQueryResult<
  ClientStandardTime[],
  APIErrorResponse
> =>
  useQueryList({
    url: `/clients/${clientId}/standard_times/`,
    options: {
      enabled: !!clientId,
    },
  })
